<template>
  <div>
    <van-nav-bar title="邻友惠" fixed right-text="关注" @click-right="onClickRight" />
    <div style="height:46px"></div>
    <vue-swpier :items="slide" autoplay="5000"></vue-swpier>

    <div class="navigation">
      <div class="item">
        <svg class="icon" aria-hidden="true" v-on:click="$router.push('/community/community')">
          <use xlink:href="#iconwuyeguanli" />
        </svg>
        <div>物业</div>
      </div>
      <div class="item">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#iconzufang" />
        </svg>
        <div>租房</div>
      </div>
      <div class="item">
        <a href="http://sihan.xmxjy.net/m/#/">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icondushu" />
          </svg>
        </a>
        <div>读书荟</div>
      </div>
      <div class="item">
        <a href="http://ywyuan.xmxjy.net/m/#/">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconhunyinzhuangtai" />
          </svg>
        </a>
        <div>姻唯缘</div>
      </div>
      <div class="item">
        <svg class="icon" aria-hidden="true" v-on:click="$router.push('/user/fenxiang/index')">
          <use xlink:href="#iconfenxiangzhuanqian" />
        </svg>
        <div>分享赚钱</div>
      </div>
    </div>
    <!-- <div class="navigation">
      <div class="item">
        <img v-on:click="nav('community')" src="@/assets/community.jpg" />
        <div>物业</div>
      </div>
      <div class="item">
        <img v-on:click="$router.push('/')" src="@/assets/shop.jpg" />
        <div>亿家商城</div>
      </div>
      <div class="item">
        <img v-on:click="$router.push('/article/detail/62')" src="@/assets/hot.jpg" />
        <div>客服</div>
      </div>
      <div class="item">
        <img v-on:click="$router.push('/second/list')" src="@/assets/second.jpg" />
        <div>闲置</div>
      </div>
      <div class="item">
        <img v-on:click="$router.push('/qiang/list')" src="@/assets/fuli.jpg" />
        <div>限时抢</div>
      </div>
    </div>-->
    <div class="zhuanqu">
      <van-divider content-position="left"></van-divider>
      <div class="title">亿家专区</div>
      <div class="list">
        <div class="item" v-for="item in zhuanqu" :key="item.id">
          <a :href="item.url">
            <img :src="GLOBAL.IMG+item.image" />
          </a>
        </div>
      </div>
    </div>
    <div class="huodong">
      <van-divider content-position="left"></van-divider>
      <!-- <div class="title">亿家活动专区</div>
      <div class="list">
        <div class="item" v-for="item in huodong" :key="item.id">
          <div class="thumb">
            <van-image width="160" height="100" fit="cover" :src="GLOBAL.IMG + item.image" />
          </div>
          <div class="r">
            <div class="title">{{item.title}}</div>
            <div>{{item.address}}</div>
      
          </div>
        </div>
      </div>-->
      <meiwen v-bind:list="huodong"></meiwen>
    </div>
    <div style="height:64px"></div>
    <TabBar active="1" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import vueSwpier from "@/components/vueSwiper.vue";
import meiwen from "./components/meiwen.vue";
import Vue from "vue";
import { Divider } from "vant";

Vue.use(Divider);
export default {
  name: "index",
  components: {
    TabBar,
    vueSwpier,
    meiwen
  },
  data() {
    return {
      slide: [],
      zhuanqu: [],
      huodong: []
    };
  },
  methods: {
     onClickRight(){
        this.$router.push("/article/detail/71");
    },
    getSlide(id) {
      this.$http
        .get(this.GLOBAL.API + "s_slide/index/slide?id=" + id, {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            if (id == 5) {
              this.slide = data.data;
            } else if (id == 4) {
              this.zhuanqu = data.data;
            }
          }
        });
    },
    getHuodong() {
      this.$http
        .get(this.GLOBAL.API + "s_portal/portal/portal_list", {
          params: { id: 17 },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.huodong = data.data;
          }
        });
    }
  },
  mounted() {
    this.getSlide(5);
    this.getSlide(4);
    this.getHuodong();
  }
};
</script>
<style lang="scss" scoped>
.navigation {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  .item {
    color: #222333;
    .icon {
      width: 70px;
      height: 50px;
    }
    img {
      width: 50px;
      height: 50px;
    }
  }
}
.zhuanqu {
  margin-top: 10px;
  .title {
    text-align: left;
    font-size: 16px;
    padding: 0 0 10px 10px;
    color: #222333;
  }
  .list {
    display: flex;
    div {
      padding: 2px;
    }
  }
}
.huodong {
  text-align: left;
  .title {
    text-align: left;
    padding-left: 10px;
    line-height: 30px;
    color: #222333;
  }
  .list {
    background-color: #f9f9f9;
    .item {
      margin-bottom: 10px;
      background-color: #f9f9f9;
      padding: 10px 10px 0 10px;
      display: flex;
      .r {
        padding-left: 10px;
        .title {
          font-size: 16px;
          line-height: 26px;
          height: 22px;
          overflow: hidden;
        }
      }
    }
  }
}
</style>